module.exports = __webpack_public_path__ + "img/roulette.e9d831e9.png";